<template>
  <div class="page-editor">
    <mt-header fixed title="选择要发货的经销商">
      <router-link to="/index/sales" slot="left">
        <mt-button icon="back">返回</mt-button>
      </router-link>
    </mt-header>
    <template v-for="dealer in dealerData">
      <a @click="goDeliver(dealer)" class="mint-cell" :key="dealer.id">
        <span class="mint-cell-mask"></span>
        <div class="mint-cell-left"></div>
        <div class="mint-cell-wrapper">
          <div class="mint-cell-title">
            <span class="mint-cell-text">{{dealer.name}}</span>
            <span class="mint-cell-label">{{dealer.address}}</span>
          </div>
          <div class="mint-cell-value is-link">
            <span></span>
          </div>
          <i class="mint-cell-allow-right"></i>
        </div>
        <div class="mint-cell-right"></div>
      </a>
    </template>
    <p v-if="dealerData.length==0" style="text-align:center;width:100%;color: #999999;">暂无经销商</p>
  </div>
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";
import { Cell, Button, Toast } from "mint-ui";

Vue.component(Button.name, Button);
Vue.component(Cell.name, Cell);
Vue.component(Toast.name, Toast);

export default {
  computed: mapState({
    dealerData: state => state.dealerData,
  }),
  methods: {
    goDeliver(dealer){
      this.$router.push({name:'salesDeliver', params: {dealer: dealer}});
    }
  },
  mounted() {
    if (this.dealerData.length==0) {
      this.$store.dispatch('loadDealerData');
    }
  }
};
</script>
<style scoped>
.page-editor {
  padding-top: 40px;
}
a {
  text-decoration: none;
}
</style>